/**
 * Title for the first image-carousel slide of an enforcement intent's session, which differs by
 * session type.
 *
 * A "capture" session is the airport (GSP) shape: a single LPR frame of the whole vehicle as it
 * enters, with no backing park or double-park event and no cropped plate image -- GSP emits no
 * `frame_type = 'crop'` frames at all -- so calling that slide a "License Plate Capture" would
 * mislabel what is on screen.
 *
 * This is the enforcement-intent counterpart to `firstCaptureSlideTitle`, which makes the same
 * distinction for a transaction. They stay separate because they key off different columns:
 * that one reads `financial.transaction.transaction_type`, this one reads
 * `enforcement.intent_session.type`.
 *
 * Lives beside `Notice.tsx` rather than with `ImageCarousel`: what a `capture` session means is
 * enforcement-intent domain knowledge, and the carousel is a generic presentational component
 * that should not need to know about session types to render a slide.
 *
 * @param sessionType Value of `enforcement.intent_session.type`, if known.
 */
export const firstSessionSlideTitle = (sessionType?: string | null): string =>
  sessionType === "capture" ? "Entry Capture" : "License Plate Capture";

export default firstSessionSlideTitle;
